import {useTranslation} from 'react-i18next';

export const ProblemRating = ({rating}: {rating?: number | null}) => {
    const {t} = useTranslation();
    if (typeof rating !== 'number' || !Number.isFinite(rating) || rating <= 0) {
        return null;
    }
    const ratingText = rating.toFixed(1);
    const ratingLabel = t('problem.rating_out_of', {
        rating: ratingText,
        total: 5,
    });

    return (
        <span
            className="dashboard-problem-rating-value"
            title={ratingLabel}>
            <i className="fa-solid fa-star" aria-hidden="true" />
            <span aria-hidden="true">{ratingText}</span>
            <span className="visually-hidden">{ratingLabel}</span>
        </span>
    );
};
